module.exports = __webpack_public_path__ + "img/icon_del_press.9557199a.svg";